import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Button } from '@mui/material';
import CatalogPartTable from './CatalogPartTable';
import CsvCatalogPartImporterModal from './CsvCatalogPartImporterModal';
import { getCatalogParts } from '../../actions/apiGetInfo';

const PartsCatalog = () => {
  const dispatch = useDispatch();
  const [importOpen, setImportOpen] = useState(false);

  useEffect(() => {
    dispatch(getCatalogParts());
  }, [dispatch]);

  return (
    <div className="container-fluid p-3">
      <div className="card mb-4">
        <div className="card-header d-flex justify-content-between align-items-center">
          <h5>Parts Catalog</h5>
          <Button variant="contained" color="primary" onClick={() => setImportOpen(true)}>
            Import CSV
          </Button>
        </div>
        <div className="card-body">
          <CatalogPartTable />
        </div>
      </div>

      <CsvCatalogPartImporterModal
        open={importOpen}
        onClose={() => setImportOpen(false)}
      />
    </div>
  );
};

export default PartsCatalog;
